module.exports = __webpack_public_path__ + "static/media/HCMM321.6766bfb1.jpg";